import React, { useEffect, useState } from 'react';
import { Box, Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, CircularProgress } from '@mui/material';
import { client } from '../api/Api';
import CalorieSilhouettesModal from './CalorieSilhouettesModal';

interface Props {
  open: boolean;
  onClose: () => void;
  receiptData: any;
}

const ReceiptNutritionModal: React.FC<Props> = ({ open, onClose, receiptData }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [summary, setSummary] = useState<any | null>(null);

  useEffect(() => {
    if (!open) return;
    if (!receiptData) return;
    const fetchNutrition = async () => {
      setLoading(true);
      setError(null);
      setSummary(null);
      try {
        const payload = {
          store_name: receiptData.store_name || receiptData.storeName,
          store_address: receiptData.store_address || receiptData.storeAddress,
          purchase_date: receiptData.purchase_date || receiptData.purchaseDate,
          items: (receiptData.items || []).map((i: any) => ({ name: i.name, nameEN: i.nameEN, price: i.price })),
        };
        const res = await client.post('/upload/nutrition', payload);
        setSummary(res.data);
      } catch (e: any) {
        setError(e?.response?.data?.message || 'Nepavyko suskaičiuoti maistingumo');
      } finally {
        setLoading(false);
      }
    };
    fetchNutrition();
  }, [open, receiptData]);

  const totalKcal = summary?.energy_kcal ?? 0;

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>Kvito maistinė analizė</DialogTitle>
      <DialogContent>
        {loading && (
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <CircularProgress size={20} />
            <Typography>Skaičiuojama...</Typography>
          </Box>
        )}
        {error && (
          <Typography color="error" variant="body2">{error}</Typography>
        )}
        {!loading && !error && summary && (
          <Box>
            <Typography variant="body1" sx={{ mb: 1 }}>
              Energija: <b>{Math.round(summary.energy_kcal)} kcal</b>
            </Typography>
            <Typography variant="body2">Baltymai: <b>{summary.protein_g} g</b></Typography>
            <Typography variant="body2">Riebalai: <b>{summary.fat_g} g</b></Typography>
            <Typography variant="body2" sx={{ mb: 2 }}>Angliavandeniai: <b>{summary.carbs_g} g</b></Typography>
            {summary.note && (
              <Typography variant="caption" sx={{ display: 'block', color: 'text.secondary', mb: 2 }}>
                {summary.note}
              </Typography>
            )}

            {/* Calorie silhouettes visualization (inline inside the same modal) */}
            <Box sx={{ mt: 2 }}>
              <CalorieSilhouettesModal inline totalCalories={totalKcal} perSilhouette={2000} title="Kalorijų vizualizacija" />
            </Box>
          </Box>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Uždaryti</Button>
      </DialogActions>
    </Dialog>
  );
};

export default ReceiptNutritionModal;
